import useStyles from '../../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import React, { useCallback, useContext, useEffect } from 'react';
import {
  CalculationTargetResourceType,
  CalculatorContext, getOrderedOptions, TargetFieldCategory,
  TargetFieldContext,
  VariableContext,
} from '../../../../../../services/common/CalculatorUtils';
import { useFormContext } from 'react-hook-form';
import CalculatorSelectInput from '../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';


const TargetFieldDossierTypeField = ({ fieldName, readOnly = false }) => {
  const { classes } = useStyles();

  const { dossierTypes } = useContext(CalculatorContext);

  const { selectedTargetFieldCategory } = useContext(TargetFieldContext);

  const { onVariableChangeCallBack, currentVariable } = useContext(
    VariableContext
  );

  const formMethods = useFormContext();
  const { setValue, clearErrors, watch, getValues } = formMethods;
  const targetResourceType = watch('targetResourceType');
  const selectedDossierType = watch('targetResourceKeys');
  const modelListField = watch(fieldName);

  const onTargetFieldDossierTypeChange = useCallback(() => {
    if (!getValues(`${fieldName}.field`) || (getValues(`${fieldName}.field`) === '')) {
      setValue(`${fieldName}.field`, '');
      clearErrors(`${fieldName}.field`, '');

      setValue(`${fieldName}.field_type`, '');
      clearErrors(`${fieldName}.field_type`, '');
    }
  }, [fieldName, setValue, clearErrors, getValues]);

  useEffect(() => {
    if (targetResourceType === CalculationTargetResourceType.DOSSIER && selectedDossierType.length) {
      setValue(`${fieldName}.dossier_type_id`, "" + selectedDossierType[0]);
    }
  }, [selectedDossierType, fieldName, targetResourceType, setValue]);

  useEffect(() => {
    if (targetResourceType === CalculationTargetResourceType.DOSSIER && selectedDossierType.length) {
      const variables = getValues('variables');
      const updatedVariable = variables.find(
        (v) => v.id === currentVariable.id
      );
      onTargetFieldDossierTypeChange();
      onVariableChangeCallBack(updatedVariable, 'dossier_type_id');
    }
    // eslint-disable-next-line
  }, [modelListField]);

  switch (selectedTargetFieldCategory) {
    case TargetFieldCategory.DOSSIER:
      return (
        <>
          <div className={classes.variableDivider}> /</div>

          <CalculatorSelectInput
            fieldName={`${fieldName}.dossier_type_id`}
            label={``}
            isRequired
            placeholder={i18next.t(
              `calculator.dialog.create.placeholder.selectValue`
            )}
            options={getOrderedOptions(dossierTypes)}
            onChange={() => {
              onTargetFieldDossierTypeChange();
              onVariableChangeCallBack(currentVariable, 'dossier_type_id');
            }}
            validate={() => {
              return null;
            }}
            variant="standard"
            labelVariant="standard"
            className={classes.inputPathVariableItem}
            disabled={targetResourceType === CalculationTargetResourceType.DOSSIER || readOnly}
          />
        </>
      );

    default:
      return <></>;
  }
};

export default TargetFieldDossierTypeField;